// English strings (source language): the setup hub (Settings › Devices) and the phone pairing dialog.

const en = {
  title: 'Your setup',
  intro: 'Connect what you ride with, then choose how you steer. Everything can be used at the same time.',
  search: 'Search for devices',
  searchMore: 'Add another device',
  searchHelp: 'One search finds trainers, power meters, sensors and Zwift controllers. Your browser shows one device at a time: search again for the next one.',
  autoOn: 'Paired devices reconnect by themselves at launch.',
  autoOff: 'This browser does not reconnect devices by itself: search again at each launch.',
  noBluetooth: 'This browser has no Bluetooth: use Chrome or Edge on a computer or an Android phone. Your phone, a gamepad and the keyboard still work as controls.',
  oneApp: 'Close Zwift and the Wahoo app first: a device often accepts only one controller.',
  status: {
    power: 'Power', hr: 'Heart rate', controls: 'Controls',
    powerOff: 'Required to ride',
    hrOff: 'Optional',
    keyboardOnly: 'Keyboard',
  },
  readyTitle: 'Ready to ride',
  notReadyTitle: 'Connect a power source to ride',
  sensors: 'Power and sensors',
  sensorsHelp: 'Your watts only come from a smart trainer or a power meter: that keeps races fair.',
  controls: 'How you steer',
  controlsHelp: 'Move across the road, use your items, shift and change the view. Use one or mix them: they all work together.',
  recommended: 'Recommended',
  state: { connected: 'Connected', ready: 'Ready', off: 'Not connected', waiting: 'Waiting', detected: 'Detected', always: 'Always on', none: 'Not detected', auto: 'Automatic' },
  zwift: {
    name: 'Zwift Play, Ride or Click',
    help: 'Handlebar controllers. Wake them up, then search for devices.',
    buttons: 'Change the buttons',
  },
  phone: {
    name: 'Your phone',
    help: 'Scan a code and your phone becomes a controller, held in your hand or on the bars. No app to install.',
    pair: 'Pair a phone',
    open: 'Show the code',
    unpair: 'Unpair',
    connected: 'Connected',
    away: 'Asleep: wake the phone to continue',
    waiting: 'Waiting for your phone',
  },
  gamepad: {
    name: 'Gamepad',
    help: 'PlayStation 5 DualSense, PS4, Xbox, Switch Pro or any pad, over USB or Bluetooth.',
    none: 'Pair it with this computer, then press one of its buttons: browsers only reveal a gamepad once it is used.',
    map: 'Cross or A uses the item, the stick or the D-pad steers, the bumpers shift.',
  },
  touch: { name: 'On-screen buttons', help: 'Tap the left or right side of a touch screen to move across the road.' },
  keyboard: { name: 'Keyboard', help: 'Always ready on a computer.', change: 'Change the keys' },
  pair: {
    title: 'Use your phone as a controller',
    intro: 'Your phone shows big buttons that follow what you ride: race, workout or arcade game.',
    scan: 'Open the camera of your phone and point it at the code.',
    type: 'Or open this address on your phone and type the code:',
    keep: 'Keep the page open on your phone: it stays awake while you ride.',
    valid: (time: string) => `Code valid for ${time}`,
    newCode: 'New code',
    connecting: 'Connecting to the server…',
    unreachable: 'The server cannot be reached. Check your connection: we keep trying.',
    signin: 'Sign in to pair a phone.',
    qrLabel: 'QR code to pair your phone',
    pairedTitle: 'Your phone is connected',
    pairedText: 'Press a button on your phone: it lights up here.',
    away: 'Your phone is asleep. Wake it up: it reconnects by itself.',
    done: 'Done',
    another: 'Pair another phone',
    unpair: 'Unpair',
    pairedToast: 'Phone connected: it now steers your rider',
    unpairedToast: 'Phone unpaired',
  },
};
export default en;
